<template>
	<modal name="mobile-landing" :adaptive="true" width="100%" height="100%">
		<div id="mobile-landing-modal">
			<div>
				<h1>{{ $t('global.mangoSongbook') }}</h1>
			</div>
			<div>
				<h2>{{ $t('global.claim.claim1') }} <strong>{{ $t('global.claim.claim2') }}</strong> {{ $t('global.claim.claim3') }}</h2>
			</div>
			<div>
				<img src="/images/loading.png">
			</div>
			<div>
				<LoginTab />
			</div>
			<div>
				<button type="button" @click="$modal.hide('mobile-landing')">{{ $t('user.anonymousButton') }}</button>
			</div>
		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import LoginTab from "../auth/LoginTab";

	export default {
		components: {LoginTab},
		computed: {
			...mapState([ "currentUser" ]),
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	#mobile-landing-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		display: flex;
		flex-direction: column;
		justify-content: space-evenly;

		> div {
			text-align: center;
		}

		button.payment-button {
			font-weight: 100;
			margin: 5px 20px 15px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #ef904e;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #d07a46;
			}

			&:focus {
				outline: none;
			}

			.icon-share {
				width: 21px;
				float: left;
				margin: 3px 0 -3px 0;
			}
		}

		img {
			width: 100px;
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 2.2em;
			font-weight: 700;
			color: #ef904e;
		}

		h2 {
			margin: 0;
			padding: 20px;
			font-size: 1.2em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}
		}
	}
</style>
